import React, { useState } from "react";
import { Box, Button, Flex, Link, Modal, Typography, useI18nContext } from "@procore/core-react";
import { Info } from "@procore/core-icons";

export const BOARDS_VIDEO_GUIDES_URL =
   "https://loom.com/share/folder/c79117f240c64b6eb7f6614414f27001";

const SHORTCUT_KEYS = ["tab", "shift_tab", "enter", "space", "esc", "arrow"] as const;

export function BoardsHelpButton() {
   const I18n = useI18nContext();
   const [isOpen, setIsOpen] = useState(false);
   const t = (key: string) => I18n.t(`views.company.workforce_planning.boards.help_modal.${key}`);

   return (
      <>
         <Button
            variant="tertiary"
            icon={<Info size="sm" />}
            onClick={() => setIsOpen(true)}
            aria-label={t("aria_label")}
         />
         <Modal open={isOpen} onClose={() => setIsOpen(false)} width="md">
            <Modal.Header onClose={() => setIsOpen(false)}>{t("title")}</Modal.Header>
            <Modal.Body>
               <Modal.Section>
                  <Typography>
                     {t("intro")}{" "}
                     <Link href={BOARDS_VIDEO_GUIDES_URL} target="_blank" rel="noopener noreferrer">
                        {t("video_guides")}
                     </Link>
                  </Typography>
               </Modal.Section>
               <Box paddingLeft="lg" paddingRight="lg" paddingBottom="lg">
                  <Flex direction="column" gap="xs">
                     {SHORTCUT_KEYS.map((key) => (
                        <Flex key={key} alignItems="center" gap="sm">
                           <span className="boards-help-shortcut-key">{t(`shortcuts.${key}`)}</span>
                           <Typography>{t(`descriptions.${key}`)}</Typography>
                        </Flex>
                     ))}
                  </Flex>
               </Box>
            </Modal.Body>
         </Modal>
      </>
   );
}
